import { z } from 'zod'

export type FieldInputType =
    | 'text'
    | 'country'
    | 'tel'
    | 'radio'
    | 'select'
    | 'number'
export interface FieldDescription {
    autoComplete?: string
    inputType?: FieldInputType
    labels?: string[]
    label?: string
    tooltip?: string
    placeHolder?: string
    className?: string
}

export interface ParsedFieldDescription extends FieldDescription {
    __brand: 'FieldDescription'
}

export const isParsedFieldDescription = (
    x: unknown,
): x is ParsedFieldDescription =>
    (x as { __brand: string }).__brand === 'FieldDescription'

export const fieldDescription = (d: FieldDescription) =>
    JSON.stringify({ ...d, __brand: 'FieldDescription' })

const defaultFieldDescription = {} satisfies FieldDescription

export const getFieldDescription = (f: z.ZodType): FieldDescription => {
    const d = JSON.parse(f.description ?? '{}')
    if (!isParsedFieldDescription(d)) {
        throw new Error('Invalid field description')
    }
    return { ...defaultFieldDescription, ...d }
}
